import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TechnicalApplicationService} from '../../api/technical-application.service';
import {FilterStorageService} from '../../services/filter-storage.service';
import {ProgressService} from '../../controls/progress.service';
import {ValidatorService} from '../validator.service';
import {IconService} from '../icon.service';
import {AddTechnicalApplicationModel} from '../../api/add-technical-application-model';
import {CategoryService} from '../category.service';

@Component({
  selector: 'app-technical-application-create',
  templateUrl: './technical-application-create.component.html',
  styleUrls: ['./technical-application-create.component.scss']
})
export class TechnicalApplicationCreateComponent implements OnInit, AfterViewInit {
  private item: AddTechnicalApplicationModel = new AddTechnicalApplicationModel();

  constructor(private route: ActivatedRoute,
              private router: Router,
              private apps: TechnicalApplicationService,
              private filters: FilterStorageService,
              private progress: ProgressService,
              private validator: ValidatorService,
              private iconService: IconService,
              private categoryService: CategoryService
  ) { }

  ngOnInit() {

  }

  async saveData() {

    if (!this.validator.validate(this.item)){
      return ;
    }

    this.progress.show();

    try {
      await this.apps.add(this.filters.getSelectedOrganization().id, this.item).toPromise();
      this.goBack();
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      this.progress.hide();
    }
  }

  goBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }

  async ngAfterViewInit() {
    try {
      const category = await this.categoryService.selectCategory();
      if (category == null) {
        this.goBack();
        return;
      }
      const icon = await this.iconService.selectImage();
      if (icon == null) {
        this.goBack();
        return;
      }

      this.item = AddTechnicalApplicationModel.build(category, icon);
    } catch (e) {
      console.error(e);
      this.goBack();
    }
  }

  async changeImage() {
    const icon = await this.iconService.selectImage();
    this.item.iconURL = icon.url;
  }
}
